import React from 'react';
import {
  SALES_RETURN_PERMISSION,
  SALES_RETURN_WORKFLOW_READ_PERMISSIONS,
} from 'pages/SalesReturn/utils/permissions';

const SalesReturnHistoryPage = React.lazy(() => import('pages/SalesReturn/SalesReturnHistoryPage'));
const SalesReturnPage = React.lazy(() => import('pages/SalesReturn/SalesReturnPage'));
const SalesReturnWorkflowQueuePage = React.lazy(() => import('pages/SalesReturn/SalesReturnWorkflowQueuePage'));
const SalesReturnWorkflowPage = React.lazy(() => import('pages/SalesReturn/SalesReturnWorkflowPage'));
const SalesReturnConfigurationPage = React.lazy(() => import('pages/SalesReturn/SalesReturnConfigurationPage'));

const salesReturnRoute = [
  {
    path: '/sales-return/discount',
    exact: true,
    name: 'Giảm giá sau bán',
    function: ['SL_ORDER_POST_SALE_DISCOUNT', SALES_RETURN_PERMISSION.INTAKE],
    requireAssigned: true,
    component: SalesReturnWorkflowPage,
  },
  {
    path: '/sales-return',
    exact: true,
    name: 'Danh sách trả hàng',
    function: SALES_RETURN_PERMISSION.VIEW,
    component: SalesReturnHistoryPage,
  },
  {
    path: '/sales-return/workflow',
    exact: true,
    name: 'Hồ sơ trả hàng cần xử lý',
    function: SALES_RETURN_WORKFLOW_READ_PERMISSIONS,
    any: true,
    component: SalesReturnWorkflowQueuePage,
  },
  {
    path: '/sales-return/configuration',
    exact: true,
    name: 'Danh mục vận hành trả hàng',
    function: [SALES_RETURN_PERMISSION.CONFIG_VIEW, SALES_RETURN_PERMISSION.CONFIG_EDIT],
    any: true,
    component: SalesReturnConfigurationPage,
  },
  {
    path: '/sales-return/add',
    exact: true,
    name: 'Tiếp nhận hồ sơ trả hàng',
    function: SALES_RETURN_PERMISSION.INTAKE,
    component: SalesReturnWorkflowPage,
  },
  {
    path: '/sales-return/case/:sales_return_case_id',
    exact: true,
    name: 'Xử lý hồ sơ trả hàng',
    function: SALES_RETURN_WORKFLOW_READ_PERMISSIONS,
    any: true,
    component: SalesReturnWorkflowPage,
  },
  {
    path: '/sales-return/legacy/add',
    exact: true,
    name: 'Tạo trả đơn bán hàng kiểu cũ',
    function: SALES_RETURN_PERMISSION.ADD,
    component: SalesReturnPage,
  },
];

export default salesReturnRoute;
